import { render, staticRenderFns } from "./CategoryProducts.vue?vue&type=template&id=2fd33260&scoped=true&"
import script from "./CategoryProducts.vue?vue&type=script&lang=js&"
export * from "./CategoryProducts.vue?vue&type=script&lang=js&"
import style0 from "./CategoryProducts.vue?vue&type=style&index=0&id=2fd33260&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd33260",
  null
  
)

export default component.exports